import useCubeItems, { PageType } from '../hooks/useCubeItems/useCubeItems'
import CubePageTemplate from '../CubePageTemplate/CubePageTemplate'
// import { useParams } from 'react-router-dom'

const Kandi = () => {
  // const { wahlkreisID } = useParams()
  // const items = useCubeItems(PageType.KANDI, wahlkreisID)
  const items = useCubeItems(PageType.PREVIEW)

  return <CubePageTemplate items={items} isPreviewMode />
}

export default Kandi
